import type { Dispatch } from 'redux'
import { connect } from 'react-redux'

import type { EventMetadata } from 'shared/store/metadata'
import { eventMetadata } from 'shared/store/metadata'
import { TimelineComponent } from './TimelineComponent'
import { fetchTimelinePageData } from 'shared/store/timeline'
import type { RootState } from 'shared/store/reducers'

const mapStateToProps = (state: RootState) => state.timelinePageState
const mapDispatchToProps = (d: Dispatch<any>) => ({
    sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    fetchPageData: () => d(fetchTimelinePageData())
})

const Timeline = connect(mapStateToProps, mapDispatchToProps)(TimelineComponent)

export { Timeline }
